import Auth from "./Auth";
import TrustupProCredential from "./Credential";

export { TrustupProCredential };

export default Auth;